export function sumAnalyticsRoleCounts(
  items: Array<{ count?: number | null }> | null | undefined,
): number {
  if (!items) {
    return 0;
  }

  return items.reduce((total, item) => total + (item.count ?? 0), 0);
}
